// =============================================================================
// ETI-113-B — Encart « Pennylane non actif » : affiché À LA PLACE d'un écran
// Pennylane quand le tenant n'a pas d'intégration Pennylane ACTIVE (accès direct).
// Charte : paire info dual-mode, aucune couleur en dur.
// =============================================================================
export default function PennylaneNonActif() {
  return (
    <div
      role="status"
      data-testid="pennylane-non-actif"
      className="rounded-lg p-4 text-sm"
      style={{
        background: "var(--oh-info-bg)",
        color: "var(--oh-info-text)",
        border: "0.5px solid var(--oh-info-border)",
      }}
    >
      L'intégration Pennylane n'est pas active pour cet espace.
    </div>
  );
}
